import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { allUserSlices } from "./slices/userSlices/allUserSlices";
import { allJobSlices } from "./slices/jobSlices/allJobSlices";

export const store = configureStore({
  reducer: {
    ...allUserSlices,
    ...allJobSlices,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
